import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import PageUrls from 'Shared/constants/PageUrls.constants';
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';
import { WpIcon } from 'Wpds/components/icon';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import { useTooltip } from 'Wpds/components/tooltip/useTooltip';
import WpTooltipOverlay from 'Wpds/components/tooltip/WpTooltipOverlay';

type Props = {
  onCloseNavbar: Function;
};

function HomePageV2Link({ onCloseNavbar }: Props) {
  const isExpanded = useContext(ExpandNavbarContext);
  const tooltip = useTooltip({ placement: 'right' });
  const { tr } = useTranslation();

  return (
    <>
      <li className="nav-item" ref={tooltip.targetRef}>
        <NavLink
          to={PageUrls.HOME_PAGE}
          exact
          className="nav-link d-flex align-items-center"
          activeClassName="active"
          onClick={onCloseNavbar}
        >
          <span
            className={cn('side-navigation-icon position-relative ', {
              'mx-auto': !isExpanded,
            })}
          >
            <WpIcon name="home-heart" />
          </span>
          {isExpanded && <div className="d-inline">{tr('perform.navigation.home')}</div>}
        </NavLink>
      </li>
      {!isExpanded && <WpTooltipOverlay context={tooltip}>{tr('perform.navigation.home')}</WpTooltipOverlay>}
    </>
  );
}

export default HomePageV2Link;
